import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import { getUnitSellingChart } from './../../services/unit/unit_selling_service';
import { getBalanceReportChart, getReportFinanceChart } from "../../services/finance/report_service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import CustomSpinner from "../../components/customs/spinner";

const DashboardChart = () => {
    const [accessToken, setAccessToken] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [year, setYear] = useState(new Date().getFullYear())
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

    const generateYears = () => {
        const startYear = currentYear - 15
        const endYear = currentYear + 15

        return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    }

    // Default data to avoid undefined values
    const [data, setData] = useState([
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
        { debit: 0, credit: 0, balance: 0 },
    ]);

    const fetchData = async (accessToken) => {
        setLoading(true);
        try {
            const params = {
                year: year,
            }
            const response = await getBalanceReportChart(accessToken, params);
            if (response.status === 200) {
                setData(response.data.data);
            }else if(response.status === 401){
                navigate('/login')
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };

    const [dataChart, setDataChart] = useState({
        series: [
            {
                name: "Pemasukan",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
                name: "Pengeluaran",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
                name: "Saldo",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        ],

        options: {
            chart: {
                type: 'area',
                height: 350,
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: ['#4CAF50', '#F44336', '#2196F3']
                },
                formatter: function (value) {
                    return new Intl.NumberFormat('id-ID', {
                        style: 'currency',
                        currency: 'IDR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    }).format(value);
                }
            },
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            title: {
                text: 'Penjualan Unit Rumah / Ruko',
                align: 'left'
            },
            // subtitle: {
            //     text: 'Tahun 2024',
            //     align: 'left'
            // },
            stroke: {
                curve: 'smooth'
            },
            yaxis: {
                opposite: true
            },
            legend: {
                horizontalAlign: 'left'
            },
            colors: ['#4CAF50', '#F44336', '#2196F3']
        }
    });

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token-terra_app');
        const userRole = localStorage.getItem('user_role-terra_app');
        if (!accessToken || !userRole) {
            navigate('/login');
        } else {
            setAccessToken(accessToken);
            setUserRole(userRole);
            fetchData(accessToken);
        }
    }, []);

    useEffect(() => {
        if (data.length > 0) {
            setDataChart((prev) => ({
                ...prev,
                series: [
                    {
                        name: "Pemasukan",
                        data: data.map((item = { debit: 0 }, index) => item.debit)
                    },
                    {
                        name: "Pengeluaran",
                        data: data.map((item = { credit: 0 }, index) => item.credit)
                    },
                    {
                        name: "Saldo",
                        data: data.map((item = { balance: 0 }, index) => item.balance)
                    }
                ],
            }));
        }
    }, [data]);

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token-terra_app');
        const userRole = localStorage.getItem('user_role-terra_app');
        if (!accessToken || !userRole) {
            navigate('/login');
        }else{
            fetchData(accessToken)
        }
    }, [year]);

    return (
        <div className="px-5">
            <label className="space-y-1">
                <div className="flex items-center gap-3">
                    <span className="pl-3 font-semibold">Pilih Tahun (Grafik)</span>
                    {loading && <CustomSpinner />}
                </div>
                <div className="relative flex items-center justify-center">
                    <select
                        value={year}
                        onChange={(e) => {
                            const newValue = e.target.value
                            setYear(newValue)
                            setCurrentYear(newValue ? Number(newValue) : 2024)
                        }}
                        className="w-full rounded-full px-3 py-2 md:py-1 appearance-none border-2"
                    >
                        <option value="" key="">semua</option>
                        {generateYears().map((item) => (
                            <option value={item}>{item}</option>
                        ))}
                    </select>
                    <FontAwesomeIcon icon={faChevronDown} className="absolute right-[8px] z-10 text-black" />
                </div>
            </label>
            <div id="chart">
                <ReactApexChart
                    options={dataChart.options}
                    series={dataChart.series}
                    type="area"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default DashboardChart;
